'use strict'

export class DonationAmount {
	constructor() {
		const user_paying_currency_switcher = document.getElementById('user_paying_currency');
		const custom_amount_input = document.getElementById('custom_amount');
		const custom_amount_inputs = document.querySelectorAll('#custom_amount, input[name="additional_custom_amount"]');
		const one_time_donation_tab = document.querySelector('.one_time_donation_button');
		const monthly_donation_tab = document.querySelector('.monthly_donation_button');
		const checkout_tabs = document.querySelector('.levcharity_checkout_tabs[data-default]');

		if (checkout_tabs?.dataset?.default == 'monthly') {
			this.changeCustomAmountPlaceholder(custom_amount_inputs, true);
		}

		if (user_paying_currency_switcher) {
			let currency_value = user_paying_currency_switcher.value;
			if (currency_value) {
				this.changeCurrencySymbolForLabels(currency_value, user_paying_currency_switcher, custom_amount_input);
			}
			user_paying_currency_switcher.addEventListener('change', (event) => {
				let selected_currency = event.target.value;
				this.changeCurrencySymbolForLabels(selected_currency, user_paying_currency_switcher, custom_amount_input);
			});
		}

		if (one_time_donation_tab) {
			one_time_donation_tab.addEventListener('click', e => {
				if (user_paying_currency_switcher) {
					this.changeCurrencySymbolForLabels(user_paying_currency_switcher.value, user_paying_currency_switcher, custom_amount_input);
				}
				this.changeCustomAmountPlaceholder(custom_amount_inputs, false);
			})
		}
		if (monthly_donation_tab) {
			monthly_donation_tab.addEventListener('click', e => {
				if (user_paying_currency_switcher) {
					this.changeCurrencySymbolForLabels(user_paying_currency_switcher.value, user_paying_currency_switcher, custom_amount_input);
				}
				this.changeCustomAmountPlaceholder(custom_amount_inputs, true);
			})
		}
	}

	changeCustomAmountPlaceholder(custom_amount_inputs, is_monthly) {
		const placeholder = is_monthly
			? wp.i18n.__("Other monthly amount", "levcharity")
			: wp.i18n.__("Other amount", "levcharity");

		custom_amount_inputs.forEach((custom_amount_input) => {
			custom_amount_input.placeholder = placeholder;
		});
	}

	changeCurrencySymbolForLabels(currency_value, user_paying_currency_switcher, custom_amount_input) {
		let option = user_paying_currency_switcher.querySelector(`option[value="${currency_value}"]`);
		if (option) {
			let currency_symbol = option.getAttribute('data-symbol');
			setTimeout(() => {
				if (currency_symbol) {
					let labels_for_currency_symbol = document.querySelectorAll('span.currency_symbol');
					let labels_for_currency_name = document.querySelectorAll('span.currency_name');

					if (labels_for_currency_symbol) {
						labels_for_currency_symbol.forEach((label) => {
							label.innerText = currency_symbol;
						});
					}
					if (custom_amount_input) {
						custom_amount_input.setAttribute('data-currency', currency_value);
						document.querySelector("label.currency_symbol").innerText = currency_symbol
					}
					if (labels_for_currency_name) {
						labels_for_currency_name.forEach((label) => {
							label.innerText = currency_value;
						});
					}
				}
			}, 100)
		}
	}

}
